// src/hooks/useUserSync.js
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const useUserSync = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const [userData, setUserData] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [showUsernameForm, setShowUsernameForm] = useState(false);

  useEffect(() => {
    const syncUserWithBackend = async () => {
      if (user) {
        try {
          const token = await getAccessTokenSilently();

          // EXACT same fetch as original
          const syncResponse = await fetch(`${API_BASE_URL}/api/users`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (!syncResponse.ok) {
            throw new Error('Failed to sync user');
          }

          const userResponse = await fetch(`${API_BASE_URL}/api/users/me`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });

          if (!userResponse.ok) {
            throw new Error('Failed to fetch user data');
          }

          const data = await userResponse.json();
          setUserData(data);

          if (!data.username) {
            setShowUsernameForm(true);
          }

        } catch (err) {
          setApiError(err.message);
          console.error('Error syncing with backend:', err);
        }
      }
    };

    syncUserWithBackend();
  }, [user, getAccessTokenSilently]);

  return {
    userData,
    apiError,
    showUsernameForm,
    setShowUsernameForm,
    setUserData
  };
};